import { useLocale } from "../hooks/useLocale";
import { msg } from "../locales/translate";
import { Box } from "@ui/box/Box";
import { TypoCaption } from "@ui/text/Typo";
import { useWindowSize } from "@ui/utils/useResize";
import { FC, PropsWithChildren } from "react";
import { BREAKPOINTS } from "src/hooks/useMobile";

type Props = PropsWithChildren & {
	busy?: boolean;
};

export const StartScreenView: FC<Props> = ({ busy, children }) => {
	useLocale();
	const size = useWindowSize();
	const isMobile = size.width <= BREAKPOINTS.mobile;
	const showSidePanel = size.width > BREAKPOINTS.tablet;

	let text = `© ${new Date().getFullYear()} Impaya Payments Ltd.`;
	if (window.location.host.includes("payswix")) {
		text = `© ${new Date().getFullYear()} Payswix, UAB.`;
	}

	return (
		<Box
			sx={{
				position: "fixed",
				top: "0",
				left: "0",
				width: "100%",
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "safe center",
				overflow: "auto",
				padding: isMobile ? "0" : "20px",
			}}>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					borderRadius: isMobile ? "0" : "12px",
					boxShadow: isMobile ? "none" : "0 4px 24px rgba(0,0,0,0.12)",
					overflow: isMobile ? "hidden" : undefined,
					position: "relative",
					width: isMobile ? "100%" : undefined,
					height: isMobile ? "100%" : undefined,
					
					// minHeight: isMobile ? undefined : "700px",
					flexShrink: 0,
				}}>
				{busy && (
					<Box
						sx={{
							position: "absolute",
							inset: "0",
							backgroundColor: "rgba(255,255,255,0.6)",
							zIndex: 10,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					/>
				)}
				{children}
				{showSidePanel && (
					<Box
						sx={{
							width: "550px",
							minHeight: "100%",
							borderRadius: "0 12px 12px 0",
							backgroundImage: "url(/bg_login.jpg)",
							backgroundSize: "cover",
							backgroundPosition: "center",
							padding: "40px",
							display: "flex",
							alignItems: "flex-end",
						}}>
						<Box>
							<TypoCaption color="white" block>
								{text}
							</TypoCaption>
							<TypoCaption color="white" block>{msg("allRightsReserved")}</TypoCaption>
						</Box>
					</Box>
				)}
			</Box>
		</Box>
	);
};
